import { render, staticRenderFns } from "./ProductSpecsElementView.vue?vue&type=template&id=0c83b48d"
import script from "./ProductSpecsElementView.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports